module.exports = __webpack_public_path__ + "static/media/autosicura_logo.5287a325.png";